import {l} from "types/typescriptdefinisjoner_lederplan";
import {IAttributes, IAugmentedJQuery, IDirective, IScope} from "angular";
import {Konfigurasjon} from "../infrastruktur/Konfigurasjon";
import {Strenger} from "../tjenester/Strenger";
import _ from "lodash";

const css = require('./avatar.scss');

export function avatarForInjisering() {
    return [Konfigurasjon.regNavn, Strenger.regNavn, avatar];
}

/**
 * Viser avatar for bruker eller gruppemedlem.
 * Bruk: <avatar bruker='brukerObj'></avatar> eller <avatar medlem='gruppeMedlemObj'></avatar>
 *
 * Farge på sirkel settes vhja class="groenn, roed eller gul"
 *
 * Ett av følgene parameter kan angis:
 * @param {l.EnkelBrukerModell} bruker brukeren vi viser avatar for
 * @param {l.GruppeMedlemListeModell} medlem gruppe-medlemmet vi viser avatar for
 * @param {string} bildeurl full url til bildet som skal vises (direktivet vil legge til autentiseringstoken)
 * @param {string} navn navnet vi vil vise intialenen for (Kai Lilleby blir KL)
 */
export function avatar(konfigurasjon: Konfigurasjon,
                       strenger: Strenger): IDirective {

    function kalkulerAvatarUrlForMedlem(medlem: l.GruppeMedlemListeModell, $scope) {
        kalkulerInitialer(medlem?.navn, $scope);
        if (!medlem) {
            $scope.url = null;
            return;
        }
        $scope.url = medlem.avatarId ? `/api/medlem/${medlem.id}/avatar/${medlem.avatarId}.jpg` : null;
    }

    function kalkulerAvatarUrlForGruppe(gruppe: l.GruppeModell, $scope) {
        kalkulerInitialer(gruppe?.organisasjonsnavn, $scope);
        if (!gruppe) {
            $scope.url = null;
            return;
        }
        $scope.url = gruppe.logoId ? `/api/gruppe/${gruppe.id}/logo/${gruppe.logoId}?format=png&bredde=${120}` : null;
    }

    function kalkulerAvatarUrlForBruker(bruker: l.EnkelBrukerModell, $scope) {
        kalkulerInitialer(bruker?.navn, $scope);
        if (!bruker) {
            $scope.url = null;
            return;
        }
        $scope.url = bruker.avatarId ? `/api/bruker/${bruker.id}/avatar/${bruker.avatarId}.jpg` : null;
    }

    function setBildeurl(url: string, $scope) {
        kalkulerInitialer(null, $scope);
        $scope.url = url;
    }

    function kalkulerInitialer(navn:string, $scope) {
        if (_.isEmpty(navn)) {
            $scope.initialer = null;
            $scope.fulltNavn = '';
            return;
        }
        $scope.initialer = strenger.initialer(navn);
        $scope.fulltNavn = navn;
    }

    return {
        restrict: "E",
        replace: true,
        scope: {
            bruker: "=",
            medlem: "=",
            gruppe: "=",
            bildeurl: "=",
            navn: "="
        },
        template: '<div class="avatar" e2e-avatar-initialer="{{initialer}}" title="{{fulltNavn}}">\
                <fk-xhr-img ng-if="url" url="url" img-class="avatar-sirkel bilde"></fk-xhr-img>\
                <div ng-if="!url && initialer" class="avatar-sirkel initialer">{{initialer}}</div>\
                <div ng-if="!url && !initialer" class="avatar-sirkel standardavatar {{ikon}}"></div>\
             </div>',

        link: function ($scope: IScope, $element: IAugmentedJQuery, $attr: IAttributes) {
            if ($attr["gruppe"])
                $scope.$watch("gruppe", (gruppe: l.GruppeModell) => kalkulerAvatarUrlForGruppe(gruppe, $scope));
            if ($attr["medlem"])
                $scope.$watch("medlem", (medlem: l.GruppeMedlemListeModell) => kalkulerAvatarUrlForMedlem(medlem, $scope));
            if ($attr["bruker"])
                $scope.$watch("bruker", (bruker: l.EnkelBrukerModell) => kalkulerAvatarUrlForBruker(bruker, $scope));

            if ($attr["bildeurl"])
                $scope.$watch("bildeurl", (bildeurl: string) => setBildeurl(bildeurl, $scope));
            if ($attr["navn"])
                $scope.$watch("navn", (navn: string) => kalkulerInitialer(navn, $scope));

            $scope["ikon"] = $attr["ikon"] || "ion-ios-person";
        }
    };
}
